import React, {useState} from "react";
import {Link, useNavigate, useLocation} from "react-router-dom";
import { useLoading } from "../Context/LoadingProvider";
import { useTranslation } from "react-i18next";
import {userService} from "../Api/Services/UserService";
import {LaravelValidationError} from "../Api/request";
import {useUser} from "../Context/UserProvider";
import {HomeIcon} from "../Components/Icons/HomeIcon";
import TalabatLogo from "../Assets/gfx/talabat.svg";
import UserNavigation from "./UserNavigation";

const ResetPassword: React.FunctionComponent<object> = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const isFirstLogin = state?.isFirstLogin === true;
  const { applyAuthToken } = useUser();
  const { startLoading, finnishLoading } = useLoading();
  const { t } = useTranslation();
  const [validationErrors, setValidationErrors] = useState<Record<string, string[]> | null>(null);
  const [password, setPassword] = useState<string>("");
    const [passwordConfirmation, setPasswordConfirmation] = useState<string>("");
    const resetPassword = () => {
        const passwordRegex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,})/;

        if (!password || !passwordConfirmation) {
            setValidationErrors({ password: ["Password fields cannot be empty"] });
            return;
        }

        if (password !== passwordConfirmation) {
            setValidationErrors({ password: ["Passwords do not match"] });
            return;
        }

        if (!passwordRegex.test(password)) {
            setValidationErrors({
                password: [
                    "Password must be at least 8 characters long, contain upper and lower case letters, and one special character",
                ],
            });
            return;
        }

        startLoading("reset-password");
        userService
            .resetPassword(password)
            .then((res) => {
                if (isFirstLogin && res?.token) {
                    applyAuthToken(res.token, res.endpoint, res.user);
                }
                navigate("/menu");
            })
            .catch((res: LaravelValidationError) => {
                setValidationErrors(res.errors);
            })
            .finally(() => {
                finnishLoading("reset-password");
            });
    };

    return (
      <div className="view-container background">
          <div className="view-content h-full flex flex-col justify-between">
          <div>
              <div className="navigationbar mb-6">
                  <div className="navigationbar__left">
                      {!isFirstLogin && (
                          <Link to="/menu" className="navigationbar__button">
                              <HomeIcon />
                          </Link>
                      )}
                  </div>
                  <div className="navigationbar__center">
                      <img src={TalabatLogo} width="95" height="20" style={{minWidth: '95px'}} alt="Talabat" />
                  </div>
                  <div className="navigationbar__right">
                      {!isFirstLogin && <UserNavigation />}
                  </div>
              </div>
          </div>

        <div className="">
            {/*<div className="heading heading--small text-center font-bold text-white">
                {t("Please update your password")}
            </div>*/}
            <div className="card-list">
                {validationErrors?.password && (
                    <div className="input-error-text">
                        {validationErrors?.password?.map((x) => (
                            <>
                                <br />
                                <span key={x} style={{ color: "red" }}>
                      {x}
                    </span>
                            </>
                        ))}
                    </div>
                )}
            </div>
          <div>
              <div className="mb-6">
                  <label className="text-white">{t('New Password')}</label>
                  <input className="input-field text-blue see-through-background mt-4" type="password" placeholder={t('Password') || ''} onChange={(e) => setPassword(e.target.value)}/>
              </div>
              <div>
                  <label className="text-white">{t('New Password')}</label>
                <input className="input-field text-blue see-through-background mb-2 mt-4" type="password" placeholder={t('Password Confirmation') || ''} onChange={(e) => setPasswordConfirmation(e.target.value)}/>
            </div>
            <div className="flex flex-col items-center mt-6">
                <button
                    className="button"
                  onClick={() => {
                    resetPassword()
                  }}
              >
                {t("Save and clear all session")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
